// handlers/LoginSuccessHandler.jsx
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAuth } from '../context/authProvider';

const AuthSuccessHandler = () => {
  const reduxAuth = useSelector((state) => {
    // console.log(state.user.user);
    //state.user.settings
    //state.user.menu
    // console.log(state);
    return state.auth;
  });
  const { setAuth } = useAuth();

      useEffect(() => {
        if (reduxAuth?.id) {
          useAuth(reduxAuth);
        }
      }, [reduxAuth]);

  return null;
};

export default AuthSuccessHandler;
